import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_PLANNING,
    DELETE_PLANNING,
    PLANNING_FORM_TOOGLE_LOADING,
    SET_PLANNING_LIST,
    SHOW_NOTIFICATION,
    UPDATE_PLANNING,
} from "../constants";
import { formatPlannings } from "./settingsActionsUtils";

/* PLANNING LIST */
export const fetchPlannings = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.plannings.list)
            .then((response) => {
                const plannings = formatPlannings(response.data);
                dispatch({
                    type: SET_PLANNING_LIST,
                    payload: keyBy(plannings, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// PLANNINGS
export const createPlanning = (newPlanning) => {
    return async (dispatch) => {
        dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.plannings.create, newPlanning)
            .then((response) => {
                const planning = formatPlannings(response.data);
                dispatch({ type: ADD_NEW_PLANNING, payload: planning });
                dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Planificación creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updatePlanning = (updatedPlanning) => {
    return async (dispatch) => {
        dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.plannings.edit}${updatedPlanning && updatedPlanning._id}`, updatedPlanning)
            .then((response) => {
                const planning = formatPlannings(response.data);
                dispatch({ type: UPDATE_PLANNING, payload: planning });
                dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Planificación actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deletePlannings = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.plannings.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_PLANNING, payload: Ids });
                dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Planificación eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: PLANNING_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
